import { styled, SvgIconProps, useTheme } from '@mui/joy';
import Typography from '@mui/joy/Typography';
import { ReactElement, ReactNode } from 'react';

export const EmptyContent = ({
  icon,
  title,
  description,
  children,
}: {
  icon: ReactElement<SvgIconProps>;
  title: string;
  description?: string;
  children?: ReactNode;
}) => {
  const theme = useTheme();

  return (
    <Container>
      <IconContainer>{icon}</IconContainer>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Typography level="section-title" textColor={theme.palette.black}>
          {title}
        </Typography>
        {description && (
          <Typography level="body-md" textColor={theme.palette.black} fontWeight={400}>
            {description}
          </Typography>
        )}
      </div>
      <div style={{ display: 'flex', gap: '6px' }}>{children}</div>
    </Container>
  );
};

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '64px 0',
  width: '100%',
  textAlign: 'center',
  gap: '24px',
});

const IconContainer = styled('div')({
  width: '64px',
  height: '64px',
});
